export const data = [
  { date: 'M01', Score: 0 },
  { date: 'M02', Score: 0 },
  { date: 'M03', Score: 0 },
  { date: 'M04', Score: 0 },
  { date: 'M05', Score: 0 },
  { date: 'M06', Score: 0 },
  { date: 'M07', Score: 0 },
  { date: 'M08', Score: 0 },
  { date: 'M09', Score: 0 },
  { date: 'M10', Score: 0 },
  { date: 'M11', Score: 0 },
  { date: 'M12', Score: 0 },
]
